export const getLastCharacter = (item) => {
  const itemAsString = item.toString();
  return itemAsString[itemAsString.length - 1];
}